define('view/template/template.history.page.view',['require','exports','module','blockit','formkit/formkit','uikit/uikit','fukit','behavior/model.lock.behavior','model/lock.model'],function(require, exports, module) {
  //prettier-ignore
  var BlocKit              = require('blockit'),
      FormKit              = require('formkit/formkit'),
      UIKit                = require('uikit/uikit'),
      SimplePaginationView = require('fukit').SimplePaginationView,
      ModelLockBehavior    = require('behavior/model.lock.behavior'),
      LockModel            = require('model/lock.model');

  var RevisionText = UIKit.Header.extend({
    template: function() {
      return 'Revision <ui name="numberView"/><ui name="inDraftView"/>';
    },

    internalViewOptions: {
      numberView: function() {
        return {
          type: UIKit.Text,
          model: this.model,
          bindings: {
            text: 'number',
          },
        };
      },
      inDraftView: function() {
        return {
          type: UIKit.Text,
          model: this.model,
          bindings: {
            text: 'publishedDate',
          },
          formatter: function(val) {
            if (!val) {
              return ' (in-draft revision)';
            } else {
              return '';
            }
          },
        };
      },
    },
  });

  var TemplateHistoryPageView = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      root: {
        type: BlocKit.ThreeColumnLayoutView,

        behaviors: {
          ModelLockBehavior: {
            model: '@state',
            modelIdAttribute: 'templateId',
            lockModelClass: LockModel,
            userIdAttribute: 'ownerUserId',
            fallbackRoute: 'template:list',
            modalOptions: {
              actions: {
                previewButton: {
                  visible: true,
                  behaviors: {
                    ResolveRouteBehavior: {
                      route: 'template:preview',
                      params: {
                        templateId: '@state.templateId',
                      },
                      behaviorClass: BlocKit.ResolveRouteBehavior,
                    },
                  },
                },
              },
            },
            behaviorClass: ModelLockBehavior,
          },
          AnswerFormRootBehavior: {
            form: '@this.form',
            behaviorClass: FormKit.Block.AnswerFormRootBehavior,
          },
        },

        pageHeader: {
          headerText: 'Form Preview',
          breadcrumbs: [
            { text: 'Forms', route: 'template:list' },
            {
              model: '@resources.revision',
              bindings: { text: 'template.name' },
              route: 'template:detail',
              params: { primaryId: '@state.templateId' },
            },
            { text: 'Revision History' },
          ],
          actions: [
            {
              text: 'Export',
              icon: 'download',
              id: 'ExportTemplate',
              showLoading: true,
              model: '@resources.revision',
              onPress: function(event) {
                $('#ExportTemplate').addClass('disabled');
                window.setTimeout(function() {
                  var jsonData = JSON.stringify(event.model.options.model.attributes.json);
                  var templateData = JSON.stringify(event.model.options.model.attributes.template)
                  var exportData = [
                     jsonData ,
                    templateData 
                ];
                  var blob = new Blob([JSON.stringify(exportData)], { type: 'application/json' });
                  var a = document.createElement('a');
                  a.style.display = 'none';
                  a.download = `${event.model.options.model.attributes.template.name}.etemplate`;
                  var url = window.URL.createObjectURL(blob);
                  a.href = url;
                  document.body.appendChild(a);
                  a.click();
                  a = null;
                  $('#ExportTemplate').removeClass('disabled');
                }, 1000);
              },
            },
            {
              text: 'Cancel and Go Back',
              icon: 'reply',
              behaviors: {
                NavigateBackBehavior: {
                  eventName: 'press',
                  routeName: 'template:detail',
                  routeParams: { primaryId: '@state.templateId' },
                  behaviorClass: BlocKit.NavigateOnEventBehavior,
                },
              },
            },
            {
              text: 'Previous',
              behaviors: {
                GoToPreviousSectionBehavior: {
                  behaviorClass: FormKit.GoToPreviousSectionBehavior,
                  form: '@this.form',
                },
              },
            },
            {
              text: 'Next',
              behaviors: {
                GoToNextSectionBehavior: {
                  behaviorClass: FormKit.GoToNextSectionBehavior,
                  form: '@this.form',
                },
              },
            },
          ],
        },

        contentColumn: {
          components: [
            {
              type: BlocKit.ContentRightTextHeaderView,
              header: {
                behaviors: {
                  BindTextToActiveSectionTitleBehavior: {
                    form: '@this.form',
                    optionName: 'text',
                    bindValueToSectionAttribute: 'text',
                    behaviorClass: FormKit.BindOptionToActiveSectionChangeBehavior,
                  },
                },
              },
              rightText: {
                type: RevisionText,
                model: '@resources.revision',
              },
            },
            {
              type: FormKit.Block.AnswerFormObjectCollectionView,
              form: '@this.form',
            },
          ],
        },

        leftColumn: {
          components: [
            {
              type: FormKit.Block.AnswerSectionMenuView,
              form: '@this.form',
            },
          ],
        },

        rightColumn: {
          components: [
            {
              type: FormKit.Block.RevisionsMenuView,
              form: '@this.form',
              collection: '@resources.revisionsHistory',
              pagination: {
                type: SimplePaginationView,
                statePageAttribute: 'revisionsPageNumber',
              },
              table: {
                childViewOptions: {
                  behaviors: {
                    NavigateOnPressBehavior: {
                      routeName: 'template:history',
                      routeParams: {
                        templateId: '@model.template.id',
                        revisionId: '@model.id',
                        revisionsPageNumber: '@state.revisionsPageNumber',
                      },
                      behaviorClass: BlocKit.NavigateOnEventBehavior,
                    },
                  },
                },
              },
              behaviors: {
                ConfirmInvokeModelMethodOnEventBehavior: {
                  eventName: 'revert',
                  method: 'revert',
                  resolveTargetModelFromEventArguments: true,
                  confirmModalOptions: function(revision) {
                    return {
                      header: {
                        text: 'Restore this revision',
                      },
                      content: {
                        icon: 'history',
                        text:
                          'Any changes made to your draft revision will be lost. ' +
                          'Are you sure you want to restore Revision ' +
                          (revision ? revision.get('number') : '') +
                          '?',
                      },
                    };
                  },
                  onMethodSuccessEvent: 'revert:success',
                  behaviorClass: BlocKit.ConfirmInvokeModelMethodOnEventBehavior,
                },
                NavigateOnRevertBehavior: {
                  eventName: 'revert:success',
                  routeName: 'template:detail',
                  resolveModelFromEventArguments: true,
                  routeParams: { primaryId: '@model.template.id' },
                  behaviorClass: BlocKit.NavigateOnEventBehavior,
                },
                SelectActiveRevisionBehavior: {
                  stateIdAttribute: 'revisionId',
                  behaviorClass: BlocKit.SelectListItemFromStateIdAttributeBehavior,
                },
              },
            },
          ],
        },
      },
    },
  });

  module.exports = TemplateHistoryPageView;
});

